import { render, staticRenderFns } from "./network.vue?vue&type=template&id=d9dc950e&"
import script from "./network.vue?vue&type=script&lang=js&"
export * from "./network.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9dc950e')) {
      api.createRecord('d9dc950e', component.options)
    } else {
      api.reload('d9dc950e', component.options)
    }
    module.hot.accept("./network.vue?vue&type=template&id=d9dc950e&", function () {
      api.rerender('d9dc950e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/network.vue"
export default component.exports